import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { InputContainer } from '../styles';

interface InputRadioProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  isError: boolean;
}

export const InputCheckbox: React.FC<InputRadioProps> = ({
  label = '',
  name,
  register,
  isError,
  ...rest
}) => {
  return (
    <InputContainer>
      <div className="spacing">
        <input id={label} {...register(name)} type="checkbox" {...rest} />
        <Form.Label htmlFor={label}>{label}</Form.Label>
      </div>
    </InputContainer>
  );
};
